const initialTimeSheetState = {
  processing: false,
  processed: false,
  sourceModel: null,
  modelConfig: [],
  combination: [],
  timeSheetAttachment: null
};

export const timeSheetReducer = (state = initialTimeSheetState, action) => {
  switch (action.type) {
    case "INIT_TIME_SHEET": {
      return { ...initialTimeSheetState };
    }
    case "INIT_TIME_SHEET_ATTACHMENT": {
      return { ...state, timeSheetAttachment: null };
    }
    case "SET_TIME_SHEET_SOURCE_MODEL": {
      return { ...state, sourceModel: action.sourceModel };
    }
    case "SET_CYCLE_COMBINATION": {
      return { ...state, combination: action.combination };
    }
    case "SET_TIME_SHEET_MODEL_CONFIG": {
      return { ...state, modelConfig: action.modelConfig };
    }
    case "SET_TIME_SHEET_ATTACHMENT": {
      return { ...state, timeSheetAttachment: action.timeSheetAttachment };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/time-sheet.js